import classNames from 'classnames';
import events from 'events-bus';
import Cookies from 'js-cookie';
import React, { useContext } from 'react';

import AppContext from '../../context';

import { getLanguageWithFlags, LanguageWithFlag } from './LanguageWithFlag';
import styles from './Multilanguage.module.scss';

export const MULTILANGUAGE_CLASS = 'srh-multilanguage';
export const MULTILANGUAGE_CHANGE_EVENT = 'MULTILANGUAGE-CHANGE-v1';

export default function Multilanguage({
    className,
}: {
    className?: string;
}): React.JSX.Element {
    const { translations, availableLanguages, vendorAssetsURL, domain } =
        useContext(AppContext);
    const languages = getLanguageWithFlags(availableLanguages, vendorAssetsURL);
    const selectedLanguage = languages.find((language) => language.selected);
    const accessibleText = translations.get(
        'shop.header.multilanguage.accessible.text',
    );

    const onChangeLanguage = (locale: string) => {
        if (locale === selectedLanguage?.locale) return;

        const language = locale.split('-')[0];
        const data = {
            version: 1,
            locale,
        };

        Cookies.set('_zpLanguage', language, {
            domain: `.${domain}`,
            sameSite: 'Lax',
            secure: true,
        });
        events.trigger(MULTILANGUAGE_CHANGE_EVENT, data);
    };

    const LANGUAGE_BUTTONS = languages.map((language) => {
        const { locale, selected, label } = language;
        const languageAriaLabel = accessibleText?.replace('${language}', label);
        return (
            <button
                data-zta={`multilanguage-buton-${locale}`}
                className={classNames(
                    `${MULTILANGUAGE_CLASS}-${locale}`,
                    styles.languageButton,
                    {
                        [styles.languageButtonSelected]: selected,
                    },
                )}
                type="button"
                key={locale}
                onClick={() => onChangeLanguage(locale)}
                aria-label={languageAriaLabel}>
                <LanguageWithFlag {...language} />
            </button>
        );
    });

    return (
        <div data-zta="multi-language" className={className}>
            <div
                data-zta="mobile-multilanguage"
                className={classNames(
                    MULTILANGUAGE_CLASS,
                    styles.mobileMultilanguage,
                )}>
                <div
                    className={styles.languageButtons}
                    data-zta="language-buttons">
                    <span
                        className={styles.languageButtonLabel}
                        data-zta="language-buttons-label">
                        {translations.get('general.language.select')}:
                    </span>
                    {LANGUAGE_BUTTONS}
                </div>
            </div>
            <div
                data-zta="desktop-multilanguage"
                className={classNames(
                    MULTILANGUAGE_CLASS,
                    styles.desktopMultilanguage,
                )}>
                {LANGUAGE_BUTTONS}
            </div>
        </div>
    );
}
